import { render, staticRenderFns } from "./EditableList.vue?vue&type=template&id=ba65a62a&"
import script from "./EditableList.vue?vue&type=script&lang=js&"
export * from "./EditableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports